window.hoculus = window.hoculus || {};
if (console && console.log) {
	console.log(
		"Coded by %cHoculus srl %con %cShopify %c- %c" +
			Shopify.theme.name +
			" %c -> https://hoculus.com",
		"color: red; font-weight: bold",
		"color: unset",
		"color: green",
		"color: unset",
		"color: blue",
		"color: unset; font-weight: bold"
	);
}
hoculus.utils = class {
	static async domreadyState() {
		return await new Promise(function (resolve, reject) {
			document.onreadystatechange = () => {
				if (document.readyState === "complete") {
					resolve(true);
				}
			};
		});
	}

	static setCookie(name,value,minutes){
		var expires = "";
		if (minutes) {
				var date = new Date();
				date.setTime(date.getTime() + (minutes*60*1000));
				expires = "; expires=" + date.toUTCString();
		}
		document.cookie = name + "=" + (value || "")  + expires + "; path=/";
	};

	static getCookie(name) {
			var nameEQ = name + "=";
			var ca = document.cookie.split(';');
			for(var i=0;i < ca.length;i++) {
					var c = ca[i];
					while (c.charAt(0)==' ') c = c.substring(1,c.length);
					if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
			}
			return null;
	};

	static asyncAssetsInterval(assetUrl, res, rej, INTERVAL_MAX_COUNT = 20, CHECK_IF_SCRIPT_LOADED_EVERY = 200 /* ms */) {
		let intervalCount = 0;

		const intervalId = setInterval(function() {
			if (hoculus.loadedAssets.includes(assetUrl)) {
				clearInterval(intervalId);
				hoculus.inProgressAssets.splice(hoculus.inProgressAssets.indexOf(assetUrl), 1);
				res(true);
			}

			if (intervalCount >= INTERVAL_MAX_COUNT) {
				clearInterval(intervalId);
				hoculus.inProgressAssets.splice(hoculus.inProgressAssets.indexOf(assetUrl), 1);
				rej("Asset not loaded", assetUrl);
			}
			intervalCount++;
		}, CHECK_IF_SCRIPT_LOADED_EVERY);
	}

	static async getScriptAsync(source, isModule = false, isNoModule = false) {
		hoculus.inProgressAssets = hoculus.inProgressAssets || [];
		hoculus.loadedAssets = hoculus.loadedAssets || [];

		return await new Promise((resolve, reject) => {
			if (hoculus.loadedAssets.includes(source) || source == "") return resolve(true);

			if (hoculus.inProgressAssets.includes(source)) this.asyncAssetsInterval(source, resolve, reject)
			else {
				hoculus.inProgressAssets.push(source);

				// Generate script tag
				var script = document.createElement("script");
				var prior = document.getElementsByTagName("script")[0];

				script.defer = 1;
				
				if (isModule) script.type = "module";
				if (isNoModule) script.noModule = 1;

				script.onload = script.onreadystatechange = function (_, isAbort) {
					if (
						isAbort ||
						!script.readyState ||
						/complete/.test(script.readyState)
					) {
						script.onload = script.onreadystatechange = null;
						script = undefined;

						if (!isAbort) {
							hoculus.loadedAssets.push(source);
							setTimeout(resolve(true), 50);
						} 
					}
				};

				script.src = source;
				prior.parentNode.insertBefore(script, prior);
			}
		});
	}

	static async getCssAsync(css) {
		hoculus.inProgressAssets = hoculus.inProgressAssets || [];
		hoculus.loadedAssets = hoculus.loadedAssets || [];

		return await new Promise(function (resolve, reject) {
			if (hoculus.loadedAssets.includes(css) || css == "") return resolve(true);

			if (hoculus.inProgressAssets.includes(css)) this.asyncAssetsInterval(css, resolve, reject);
			else {
				hoculus.inProgressAssets.push(css);

				// Generate link tag
				let link = document.createElement("link");
				link.setAttribute("rel", "stylesheet");
				link.setAttribute("href", css);

				link.onload = function() {
					hoculus.loadedAssets.push(css);
					resolve(true);
				};
				
				link.onerror = function() {
					hoculus.inProgressAssets.splice(hoculus.inProgressAssets.indexOf(css), 1);
					reject("CSS not loaded");
				};

				document.head.appendChild(link);
			}
		});
	}

	static onInteraction() {
		hoculus.interacted = hoculus.interacted || false;
		if (hoculus.interacted == false) {
			console.log("Interacted");
			["click", "scroll", "touchstart", "mousemove"].forEach(function (evt) {
				document.removeEventListener(evt, hoculus.utils.onInteraction)
			})
			hoculus.onInteractionCallback();
			hoculus.interacted = true;
		}
	}
}

// --- START ---
// This function is called when the user interacts with the page for the first time
hoculus.onInteractionFunctions = [];
hoculus.onInteractionCallback = function () {
	if (hoculus.theme.settings.tracking.clarity && window.Shopify.theme.role == 'main') {
		hoculus.clarity(window, document, "clarity", "script", "lkoeiyoxw6");
	}
	hoculus.onInteractionFunctions.forEach(fn => fn());
}
// --- END ---

hoculus.mainProductCheckbox = class extends HTMLElement {
  	constructor() {
		super()
		this.checkbox = this.querySelector("input[type=checkbox]")
		this.inputs = this.querySelectorAll("input[type=hidden]")
		this.productForm = document.querySelector("#product-form-container > form")
		this.checkbox.addEventListener("input", this.onCheckboxChange.bind(this))
  	}

	onCheckboxChange() {
		const isChecked = this.checkbox.checked;
		if (isChecked) this.inputs.forEach(input => this.productForm.appendChild(input))
		else this.inputs.forEach(input => this.productForm.removeChild(input))
	}
}

hoculus.modal = class extends HTMLElement {
	constructor() {
		super();
		this.modalId = this.dataset.modalId
		this.closeBtn = this.querySelector(".hoculus-close-modal")
		this.backdrop = this.querySelector(".hoculus-backdrop")

		// Remove fragment from URL
		document.querySelectorAll(`a[href='#${this.modalId}'`).forEach(link => link.addEventListener("click", () => history.replaceState("", document.title, window.location.pathname + window.location.search)));

		window.addEventListener("hashchange", () => {
			const hash = window.location.hash.slice(1)
			if (hash === this.modalId) {
				this.classList.add("visible")
				document.body.style.overflow = "hidden"
			}
		})

		;[this.closeBtn, this.backdrop].forEach(el => {
			el.addEventListener("click", () => {
				this.classList.remove("visible")
				history.replaceState({}, document.title, window.location.pathname + window.location.search)
				document.body.style.overflow = ""
			})
		})
	}
}

hoculus.addToCart = class extends HTMLElement {
	constructor() {
		super()
		this.quantity = +this.dataset.quantity
		this.variant = +this.dataset.variant
		this.properties = JSON.parse(this.dataset.properties || "{}")

		this.querySelector("span.link").addEventListener("click", this.addToCart.bind(this))
	}
	addToCart() {
		const formData = {
			'items': [{
				'id': this.variant,
				'quantity': this.quantity,
				'properties': this.properties
			}],
			'sections': 'cart-template,ajax-cart',
			'sections_url': theme.routes.searchUrl
		 };
		 fetch(window.Shopify.routes.root + 'cart/add.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(formData)
		})
		.then(response => {
			return response.json();
		})
		.then(response => {
			document.dispatchEvent(
				new CustomEvent("cart-add", { detail: response })
			);
			fetch(theme.routes.cartGet, { dataType: "json" }).then((e) =>
				Object.assign(window, e)
			).then((response) =>
				document.dispatchEvent(
					new CustomEvent("cart-change", { detail: response })
				)
			);
		})
		.catch((error) => {
			console.error('Error:', error);
		});		 
	}
}

/* 
How it works:

Thumbs
Pass data-main-slider-selector="main slider selector" attribute to on the thumbs slider and data-has-thumbs="true" on the main slider

Sync 2 slider
Pass data-sync-slider="unique-id" to both sliders, pass same id to both sliders
*/
hoculus.swiperSlider = class extends HTMLElement {
	static observedAttributes = ["go-to-slide"];
	selectors = {
		sliderContainer: '.swiper-wrapper',
		pagination: '.swiper-pagination',
		arrowNext: '.swiper-button-next',
		arrowPrev: '.swiper-button-prev',
	}

	// Add this data attribute to sync 2 sliders, its value should be the same for both sliders
	syncSlider = this.dataset.syncSlider;

	mediaCount = this.dataset.mediaCount;
	
	constructor() {	
		super();

		
		if (this.mediaCount == 1) {
			console.log("===>", this.mediaCount);
			console.log(this);
			this.addZoom();
			return;
		}

		this.settings = JSON.parse(this.dataset.swiperSettings);
		this.sliderConfig = JSON.parse(this.dataset.swiperSettings);

		// Some of the swipers in the past were setup with string values, we have take each of those settings and turn them to numbers or booleans
		// We start by declaring each setting that must be fixed
		this.stringSettingsArray = ["loop", "distanceBetween", "slidesPerView", "autoplay", "autoplayDelay"];

		// Go through every setting in the current settings object and check if it's a string, then check if it can be converted to either a number or a boolean
		for (const setting of this.stringSettingsArray) {
			let sliderSetting = this.sliderConfig[setting];
			if (sliderSetting !== null && typeof sliderSetting == "string") {
				if (!isNaN(Number(sliderSetting))) {
					this.sliderConfig[setting] = Number(sliderSetting);
				} else if(sliderSetting === "true" || sliderSetting === "false") {
					this.sliderConfig[setting] = sliderSetting === "true";
				}
			}
		}

		if (this.querySelector(this.selectors.arrowNext) && this.querySelector(this.selectors.arrowPrev)) {
			this.sliderConfig.navigation = {
				nextEl: this.selectors.arrowNext,
				prevEl: this.selectors.arrowPrev,
			}
		}

		if (this.querySelector(this.selectors.pagination)) {
			this.sliderConfig.pagination = {
				el: this.selectors.pagination,
				clickable: true,
			}
		}
		
		this.sliderConfig.watchSlidesProgress = true;

		if (this.settings.autoplay === "true" || this.settings.autoplay === true ) this.sliderConfig.autoplay = { delay: parseInt(this.settings.autoplayDelay) }
		this.sliderConfig.on = {
			afterInit: this.onSliderInit()
		}
		if(this.settings.on && this.settings.on.slideChangeTransitionEnd) {
			this.sliderConfig.on.slideChangeTransitionEnd = eval("(" + this.settings.on.slideChangeTransitionEnd + ")")
		}
		this.sliderContainer = this.querySelector(this.selectors.sliderContainer);
		this.slider = this.querySelector(this.selectors.sliderContainer);
		if (this.settings.loadOnInteraction === true) {
			hoculus.onInteractionFunctions.push(this.initSlider.bind(this));
		}else{
			this.initSlider();
		}
	}

	addZoom() {
		if (this.dataset.zoom !== undefined) {
			this.addEventListener("click", (evt) => {
				document.querySelector(this.dataset.zoom).openZoom();
			});
		}
	}

	async initSlider(fromThumbs = false) {
		if (this.dataset.hasThumbs && !fromThumbs) return;
		Promise.allSettled([
			hoculus.utils.getScriptAsync(hoculus.theme.assets.js.swiper),
            hoculus.utils.getCssAsync(hoculus.theme.assets.css.swiper)
        ]).then(() => {
			this.swiper = new Swiper(this, this.sliderConfig);
			this.addZoom();

			if (this.selectors.mainSliderSelector) document.querySelector(this.selectors.mainSliderSelector)?.initSlider(true);

			const syncSliders = document.querySelectorAll(`hoculus-swiper-slider[data-sync-slider="${this.syncSlider}"]`);
			if (syncSliders?.length === 2) syncSliders.forEach((slider, idx) => {
				if (slider?.swiper?.controller) slider.swiper.controller.control = syncSliders[idx + 1]?.swiper ?? syncSliders[0]?.swiper;
			});

			document.querySelector("#hoculus-main-product-media")?.classList.add("show-main-media");
        });
	}
	onSliderInit() {
		setTimeout(() => {
			this.classList.remove("swiper-hidden");
		}, 500);
	}
	attributeChangedCallback(name, oldValue, newValue) {
		if (name == 'go-to-slide') this.swiper.slideTo(parseInt(newValue), 0, false)
	}
}

// Set description images in collection vendors page
const collectionVendors = document.getElementById("collection-vendors");
if (collectionVendors) {
	const descLazyImages = document.querySelectorAll("[data-lazy-src]");

	const callback = (entries, observer) => {
		const [entry] = entries;
		if (!entry.isIntersecting) return;
		entry.target.src = entry.target.dataset.lazySrc;
		observer.unobserve(entry.target)
	}

	const lazyImagesObserver = new IntersectionObserver(callback, { root: null, threshold: 0 });
	
	descLazyImages.forEach(lazyImage => lazyImagesObserver.observe(lazyImage));
}

// Hoculus custom invoice
hoculus.customInvoice = class extends HTMLElement {
	selectors = {
		vat: "#hoculus-custom-invoice-vat",
		sdi: "#hoculus-custom-invoice-sdi",
	}

	constructor() {
		super();
		this.data = {
			hoculusCustomInvoiceVat: this.querySelector(this.selectors.vat),
			hoculusCustomInvoiceSdi: this.querySelector(this.selectors.sdi)
		};
		this.details = this.querySelector("details");
	}

	connectedCallback() {
		for (const [k,v] of Object.entries(this.data)) {
			v.value = hoculus.utils.getCookie(k);
			v.addEventListener("input", this.onInput.bind(this, k, v))
			v.addEventListener("invalid", () => {
				this.details.open = true
			})
		}
		this.checkRequired()
	}

	onInput(name, element) {
		hoculus.utils.setCookie(name, element.value);
		this.checkRequired()
	}

	checkRequired() {
		var requiredFields = false
		// check for non empty fields
		for (const [k, v] of Object.entries(this.data)) {
			if(v.value != ''){
				requiredFields =  true;
				break;
			}
		}
		// if any, make all fields required
		for (const [k, v] of Object.entries(this.data)) {
			const label = v.nextElementSibling || v.previousElementSibling

			if (requiredFields) {
				label.textContent = label.textContent.replace('*', '')
				v.required = true
				label.textContent = '*' + label.textContent
			} else {
				v.required = false
				label.textContent = label.textContent.replace('*', '')
				v.placeholder = ""
			}
		}
	}
};

// Hoculus image zoom
hoculus.productImageZoom = class extends HTMLElement {
	constructor() {
		super();
		this.mainProductSlider = document.querySelector(this.dataset.mainSliderSelector);
		this.zoomProductSlider = document.querySelector('hoculus-swiper-slider');
		this.mainProductSlider?.addEventListener("click", this.openZoom.bind(this));
		this.mainProductSlider?.addEventListener("mainSliderIndexChanged",this.updateSlider.bind(this),false);
		this.querySelector(".image-zoom__close-btn").addEventListener("click", this.closeZoom.bind(this));
	}
	updateSlider(evt) {
		this.zoomProductSlider.setAttribute("go-to-slide", evt.detail.newIndex - 1)
	}

	openZoom(evt) {
		this.classList.add("visible");
	}

	closeZoom() {
		this.classList.remove("visible");
	}
}

hoculus.hoculusCartLineItem = class extends HTMLElement {
	constructor() {
		super();
		this.removeButton = this.querySelector("a.hoculus-remove-item");
		this.key = this.dataset.key;
		this.removeFetchUrl = Shopify.routes.root + "cart/change.json";
		this.sectionId = this.dataset.sectionId;
	}

	connectedCallback() {
		this.removeButton.addEventListener('click', ()=> {
			Cart.remove(this.key, [this.sectionId]).then((res) => {
				const dropDownString = new DOMParser()
					.parseFromString(res.sections[this.dataset.sectionId], "text/html")
					.querySelector(`#dropdown-cart-template`).innerHTML;
				const dropdownHtml = new DOMParser().parseFromString(dropDownString, "text/html").querySelector(".js-header-dropdown-cart");
				document.querySelector(`.js-header-dropdown-cart`).innerHTML = dropdownHtml.innerHTML;
			})
		});

	}

	renderSection(data) {
		const newSection = document.createElement("section");
		newSection.innerHTML = Object.values(data.sections)[0];
		const oldSection = document.querySelector("#cart-line-items");
		oldSection.innerHTML = newSection.querySelector("section").innerHTML;
	}

	async getSection() {
        try {
            const res = await fetch(`${window.Shopify.routes.root}?sections=${this.sectionId}`);

            if (!res.ok) throw new Error("Failed to fetch section.");

            const data = await res.json();

            const sectionHTML = new DOMParser()
                .parseFromString(data[this.sectionId], "text/html")
                .querySelector(`#shopify-section-${this.sectionId}`).innerHTML;

            document.querySelector(`#shopify-section-${this.sectionId}`).innerHTML = sectionHTML;
        } catch (err) {
            console.error(err);
        }
    }

	async getCart() {
		try {
			const response = await fetch('/cart.js');
			const data = await response.json();
			return data;
		} catch (error) {
			console.error('Error fetching cart:', error);
			throw error;
		}
	}

	changeQuantity(originalQuantity) {
		console.log(originalQuantity);
	}
	
	async removeItem() {
		this.removeButton.classList.add("pending");
		const data = {
			id: this.key,
			quantity: 0,
			sections: [this.sectionId]
		}

		fetch(this.removeFetchUrl,{
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(data)
		})
		.then(response => response.json())
		.then((data) => {
			this.renderSection(data);
		})
		.catch((error) => {
			console.error(error);
		})
		.finally(() => {
			this.removeButton.classList.remove("pending");
		});
	}
}

hoculus.heroSlider = class extends HTMLElement {
	constructor() {
	  	super();
		this.slider = this.querySelector("slider-component");
		this.slides = this.querySelectorAll('.slide-bg');
		this.slider.dataset.loop === "true" && this.slides.length > 1 ? this.activeSlide = this.slides[1] : this.activeSlide = this.slides[0];
	}
	connectedCallback() {
		// If loop is enabled a new slide is added as the first so all elements are shifted by 1
		this.playSlide(this.activeSlide);
		// tiny-slider is initialized asynchronously via section onLoad/IntersectionObserver,
		// so we wait with rAF until this.slider.slider is ready before attaching the event.
		const waitForSlider = () => {
			if (this.slider.slider?.events) {
				this.slider.slider.events.on('indexChanged', info => this.handleChange(info));
			} else {
				requestAnimationFrame(waitForSlider);
			}
		};
		waitForSlider();
	}
	playSlide(slide){
		const videoArray = slide.querySelectorAll('video');
		for (const video of videoArray) {
			if (window.getComputedStyle(video.parentNode).display !== "none" && video.hasAttribute("autoplay")) {
				// Get the currently visible video (in case there's both desktop and mobile videos)
				video.play();
				return;
			};
		}
	}
	pauseAllVideos() {
		this.slides.forEach((slide) => {
			const video = slide.querySelector('video');
			if (video) {
				video.pause();
			}
		});
	}
	handleChange(info) {
		// changing the active slide
		this.activeSlide = this.slides[info.index];
		// Pause all videos
		this.pauseAllVideos();
		// Play the video in the active slide
		this.playSlide(this.activeSlide);
	};
}

hoculus.multiPosition = class extends HTMLElement {
	constructor() {
		super();
		this.link = this.dataset.link;
		this.multiPositions = document.querySelectorAll(`hoculus-multi-position`);
		if(window.multiPositionResizeObserver !== true) {
			window.addEventListener("resize", (event) => { 
				this.multiPositions.forEach((el) => el.switchItem());
			});
			window.multiPositionResizeObserver = true;
		}
	}
	connectedCallback() { 
		this.switchItem();
	}
	switchItem() {
		if (this.isVisible() && this.hasChildNodes() === false) {
			for(const link of document.querySelectorAll(`hoculus-multi-position[data-link="${this.link}"]`)){
				if (link != this, link.hasChildNodes() && link.firstElementChild){
					this.appendChild(link.firstElementChild);
					link.innerHTML = '';
					break;
				}
			}
		}
	}
	isVisible() {
		const style = window.getComputedStyle(this);
		return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
	}
}

hoculus.hoculusPopup = class extends HTMLElement {
    constructor() {
        super();
        this.querySelector(".close-popup")?.addEventListener("click", () => this.closePopup());
		this.classList.add("hoculus-popup");
		this.addEventListener('click', (event)=> {if (event.target === event.currentTarget) this.closePopup()});
    }

    closePopup() { this.classList.remove("is-open") };
    openPopup() { this.classList.add("is-open") };
}

hoculus.hoculusIsolatedAddToCart = class extends HTMLElement {
	constructor() {
		super();
		this.variantId = this.querySelector("input").value;
		this.disableAfter = this.dataset.disableAfter === "true"
	}

	async addToCart() {
        Cart.add(this.querySelector('form'))
			.catch((error)=>{
				console.error(error);
			})
			.finally(() => {
				this.querySelector("button[type=submit]").disabled = false;
			});
    }

	clickHandler(event) {
		event.preventDefault();
		this.querySelector("button[type=submit]").disabled = true;
		this.addToCart();
	}

	connectedCallback() {
		this.addEventListener('click',(event)=> this.clickHandler(event))
	}
}

hoculus.hoculusPostCtaPopup = class extends hoculus.hoculusPopup {
    constructor() {
        super();
		this.ctaArray = this.querySelectorAll('hoculus-isolated-add-to-cart');
    }

	// New add to cart method that modifies the DOM
	async addToCart() {
		Cart.add(this.querySelector('form'))
		.then(()=> { if (this.disableAfter) this.parentNode.classList.add("popup-card-checked") })
		.catch((error)=>{
			console.error(error);
			this.parentNode.classList.add("popup-card-error");
			const messageDiv = this.parentNode.querySelector('.error-message');
			messageDiv.classList.add('show-message');
			messageDiv.children[0].innerText = error.description;
			setTimeout(() => {
				messageDiv.classList.remove('show-message');
				if (!this.disableAfter) this.parentNode.classList.remove("popup-card-error");
			}, 5000);
		})
		.finally(() => {
			this.querySelector("button[type=submit]").disabled = false;
		});
	}

	connectedCallback() {
		// Override addToCart method
		for (const cta of this.ctaArray) {
			cta.addToCart = this.addToCart;
		}

		// Shows popup after adding to cart
		document.addEventListener("cart-add",()=> this.openPopup());
	}
}

// Clarity
hoculus.clarity = function (c, l, a, r, i, block = false) {
	c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments) };
	const t = l.createElement(r); t.async = 1; t.src = "https://www.clarity.ms/tag/" + i;
	if (block == true) {
		t.type = "text/plain";
		t.dataset.cookieType = "analytics";
	}
	const y = l.getElementsByTagName(r)[0];
	y.parentNode.insertBefore(t, y);
};

hoculus.utils.domreadyState().then(async () => {
	["click", "scroll", "touchstart", "mousemove"].forEach(evt => document.addEventListener(evt, hoculus.utils.onInteraction, false));

	customElements.define("hoculus-main-product-checkbox", hoculus.mainProductCheckbox)
	customElements.define("hoculus-modal", hoculus.modal);
	customElements.define("hoculus-add-to-cart", hoculus.addToCart);
	customElements.define("hoculus-swiper-slider", hoculus.swiperSlider);
	
	customElements.define("hoculus-invoice-details", hoculus.customInvoice);
	customElements.define("hoculus-product-image-zoom", hoculus.productImageZoom);
	customElements.define("hoculus-hero-slider", hoculus.heroSlider);
	customElements.define("hoculus-cart-line-item", hoculus.hoculusCartLineItem);
	customElements.define("hoculus-popup", hoculus.hoculusPopup);
	customElements.define("hoculus-isolated-add-to-cart", hoculus.hoculusIsolatedAddToCart);
	customElements.define("hoculus-post-cta-popup", hoculus.hoculusPostCtaPopup);


	customElements.define("hoculus-multi-position", hoculus.multiPosition);
	// hoculus.utils.getScriptAsync("//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js", false, false);
	if (hoculus.themeSettings.scalapayIsActive) {
		hoculus.utils.getScriptAsync("https://cdn.scalapay.com/widget/v3/js/scalapay-widget.esm.js", true, false); // module - async
		hoculus.utils.getScriptAsync("https://cdn.scalapay.com/widget/v3/js/scalapay-widget.js", false, true)		// nomodule - async
	}
})

for (let header of document.querySelectorAll('#tab-content-description h1')) {
    // I gave these variables real names, very good practice
    var new_header = document.createElement('h2');
    new_header.innerHTML = header.innerHTML;

    header.parentNode.replaceChild(new_header, header);
}


// Punto 12 — TrustPilot lazy init via IntersectionObserver
// Activates .trustpilot-widget-lazy elements only when they enter the viewport.
// Avoids iframe creation cost until user actually scrolls to the widget.
(function () {
  function initTpLazy() {
    var lazyWidgets = document.querySelectorAll('.trustpilot-widget-lazy');
    if (!lazyWidgets.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        // Swap class so TrustPilot bootstrap recognises the element
        el.classList.remove('trustpilot-widget-lazy');
        el.classList.add('trustpilot-widget');
        // Use TrustPilot's own API if available; otherwise the bootstrap
        // script's MutationObserver will pick it up automatically.
        if (window.Trustpilot && typeof window.Trustpilot.loadFromElement === 'function') {
          window.Trustpilot.loadFromElement(el, true);
        }
        observer.unobserve(el);
      });
    }, { rootMargin: '200px 0px' }); // start loading 200px before entering view

    lazyWidgets.forEach(function (w) { observer.observe(w); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTpLazy);
  } else {
    initTpLazy();
  }
})();
